import { formatSplitKey } from "../commons/FormatValue";
import { filteredNoneItemInArray } from "./ManageArray";

const initializeSetOption = ({ key = "", label = "", dataset = [] }) => {
  const options = dataset.map((row) => ({
    value: `${formatSplitKey(key, ".", row)}`,
    label:  `${formatSplitKey(label || key, ".", row)}`
  }));
  return filteredNoneItemInArray(options, "value", "");
};

const initializeSetOptionMulti = ({
  key = "",
  label = [],
  dataset = [],
  operator = " / "
}) => {
  const options = dataset.map((row) => ({
    value: `${formatSplitKey(key, ".", row)}`,
    label: `${formatSplitKey(label[0], ".", row)}${operator}${formatSplitKey(
      label[1],
      ".",
      row
    )}`
  }));
  return filteredNoneItemInArray(options, "value", "");
};

const initializeSetOptionDisabled = (
  options = { key: "", label: "", type: "", dataset: [] },
  disabled = { key: "", value: "", data: [] }
) => {
  const setOption =
    options.type === "Multi"
      ? initializeSetOptionMulti(options)
      : initializeSetOption(options);
  const setOptionDisabled = setOption.map((item) => ({
    ...item,
    disabled:
      disabled?.data.some(
        (dis) =>
          `${formatSplitKey(disabled?.key, ".", dis)}` === `${item.value}`
      ) || `${disabled?.value}` === `${item.value}`
  }));
  return filteredNoneItemInArray(setOptionDisabled, "value", "");
};

export {
  initializeSetOption,
  initializeSetOptionMulti,
  initializeSetOptionDisabled
};
